module.exports = __webpack_public_path__ + "img/discount-pc.36551fb1.jpg";